import { assert } from 'superstruct';
import { validateConfig } from './validateConfig';
import {
  fetchGameListData,
  filterPlayForFunGames,
} from '../../entities/gameList';
import { getSDKConfig } from '../../shares/lib/getSDKConfig';
import { SwipeGamesConfigSchema } from '../../shares/model/swipe';
import logger from '../../shares/lib/logger';

export const setSwipeSdkConfig = async (): Promise<boolean> => {
  const swipeSDKConfig = getSDKConfig();

  if (!swipeSDKConfig.enableSwipeGames || !swipeSDKConfig.swipeGames) {
    return false;
  }

  const gameListData = await fetchGameListData(swipeSDKConfig);
  const swipeGames = swipeSDKConfig.swipeGames;

  swipeGames.gameListConfig.gameList = filterPlayForFunGames(
    swipeGames.playForFunMode,
    gameListData,
  );

  assert(swipeSDKConfig.swipeGames, SwipeGamesConfigSchema);

  const configValidation = validateConfig(swipeSDKConfig.swipeGames);

  if (Array.isArray(configValidation)) {
    logger.error('Configuration Errors', configValidation);
    return false;
  }

  if (gameListData.length === 0) {
    logger.error('No games found in the configuration');
    return false;
  }

  return true;
};
